import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {Router} from '@angular/router';
import {AuthService} from 'src/app/services/auth.service';
import {CaexService} from 'src/app/services/caex.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';

@Component({
  selector: 'app-caex-toten',
  templateUrl: './caex-toten.component.html',
  styleUrls: [ './caex-toten.component.scss' ]
})
export class CaexTotenComponent implements OnInit {

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'name', 'register' ];
  
  public spinner: boolean;

  constructor (
    public _authService: AuthService,
    public _caexService: CaexService,
    private router: Router,
    private dialog: MatDialog) { 

      if (!this._caexService.currentMember || !this._caexService.memberOrders) {
        this.router.navigate([ 'caex' ]);
      }

      this.dataSource = new MatTableDataSource(this._caexService.memberOrders);

    }

  ngOnInit () {
  }

  registerPresenceDialog (element, direction) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '300px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Registrar", message: "<br>Registrar esta presença?"}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this.registerPresence(element, direction)
      }
    })
  }

  registerPresence (order, direction) {
    this.spinner = true
    //  console.log(JSON.stringify(data))
    if (direction) {
      order.register_type = "Entrance"
    } else {
      order.register_type = "Exit"
    }

    this._caexService.registerPresence(order)
      .subscribe((data) => {
        console.log("registerPresence result: " + JSON.stringify(data.result))
        this.spinner = false
      })
    //.unsubscribe()

  }

  goBack () {
    this.router.navigate([ 'caex' ]);
  }

}
